(function() {
  var externalSrc = 'https://cdn.trustindex.io/loader.js?7c758ac64ace6207770682eb451';

  function mountWidget() {
    var mount = document.querySelector('[data-trustindex-page-mount]');
    var widgetSrc;

    if (!mount) {
      return false;
    }

    widgetSrc = mount.getAttribute('data-trustindex-src') || externalSrc;

    if (mount.querySelector('script[data-trustindex-external]') || mount.getAttribute('data-trustindex-loaded') === 'true') {
      return true;
    }

    var script = document.createElement('script');
    script.src = widgetSrc;
    script.defer = true;
    script.async = true;
    script.setAttribute('data-trustindex-external', 'true');
    mount.setAttribute('data-trustindex-loaded', 'true');
    mount.appendChild(script);
    return true;
  }

  if (!mountWidget()) {
    document.addEventListener('DOMContentLoaded', mountWidget, { once: true });
  }
})();
